export { MicPermissionBanner } from './components/MicPermissionBanner'
export { useMicPermission } from './hooks/useMicPermission'
export type {
  MicPermissionState,
  UseMicPermissionReturnIProps,
} from './hooks/useMicPermission'
